import { atom } from 'jotai';

import { toBoolean } from '@/lib/toBoolean';

export const isReferralFeatureEnabledAtom = atom((get) => {
    if (import.meta.env.DEV) {
        return true;
    }

    const isReferralFeatureEnabledLocally = localStorage.getItem(
        'isReferralFeatureEnabled',
    );
    if (
        isReferralFeatureEnabledLocally &&
        toBoolean(isReferralFeatureEnabledLocally)
    ) {
        return true;
    }

    return false;
});
